export default {
  namePattern: /^[a-z].?/i,
  emailPattern: /^[\w+-.]+@([\w-]+\.)+[\w-]{2,6}$/,
  phonePattern:
    /((?:\+|00)[17][ -]?|(?:\+|00)[1-9]\d{0,2}[ -]?|(?:\+|00)1-\d{3}[ -]?)?(0\d|\(\d{3}\)|[1-9]{0,3})(?:([ -]\d{2}){4}|((?:\d{2}){4})|([ -]\d{3}[ -]\d{4})|(\d{7}))/,
  passcodePattern: /^\d+$/,
};
